import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    height: 100%;
    padding: 24px;
    /* position: absolute; */
    top: 11%;
    z-index: 999;
`;

export const Span = styled.span`
    display: inline-block;
    padding: 0 0 8px;

    position: relative;
    display: inline-flex;
    align-items: center;
    max-width: 100%;
    height: 32px;
    color: rgba(0, 0, 0, .85);
    font-size: 14px;
    &::after {
        color: red;
        display: inline-block !important;
        margin-left: 4px !important;
        font-size: 14px !important;
        line-height: 1 !important;
        content: "*" !important;
    }
`;

export const Title = styled.h2`
  margin-bottom: 8px;
  font-weight: bold;
  font-size: 15px;
  display: flex;
  align-items: center;
  gap: 8px;
`;